// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"aeca62f9","816":"9be8d924"}[chunkId] + ".chunk.js";
};